import {
  getQueryString,
  updateFilterStore,
  normalizeFilterQuery,
} from 'pages/category/util'
import filterDuck from 'components/filter/filter-options/duck'

const syncRoutePathForSearch = ({ filterData, sortData } = {}) => {
  const pathPrefix = window.location.pathname
  let textQuery = ''
  const { queryString } = getQueryString({ filterData, sortData })
  if (queryString) {
    textQuery = `?${queryString}`
  }

  // Update the url without a reload. replaceState (not pushState) so the
  // search page has one history entry: Back leaves it in one press. Keep
  // Next's state so Back/Forward to this entry still routes correctly.
  const url = `${pathPrefix}${textQuery}`
  window.history.replaceState({ ...window.history.state, as: url }, '', url)
}

const getFiltersFromQuery = ({
  brandQuery,
  categoriesQuery,
  categoryQuery,
  colorQuery,
  priceQuery,
  sizeQuery,
  store,
  asPath,
}) => {
  store.dispatch(filterDuck.creators.clean())

  const filterData = normalizeFilterQuery({
    sizeQuery,
    brandQuery,
    priceQuery,
    colorQuery,
    asPath,
    isSearch: true,
  })

  if (
    [
      sizeQuery,
      brandQuery,
      categoryQuery,
      categoriesQuery,
      priceQuery,
      colorQuery,
    ].some(Boolean)
  ) {
    updateFilterStore(filterData, store)
  }

  return filterData
}

export { syncRoutePathForSearch, getFiltersFromQuery }
